export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Это действие навсегда удалит актив"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы уверены, что хотите продолжить?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы больше не увидите этот актив в своем списке."])}
}